import { IdXboxProgramDataResponse } from "../../server/crm/api/models/idXboxProgramModels";
import { IdXboxProgramScope } from "../scopes";
import { createOnboardingAsyncAction } from "./helpers/actionCreators";

export enum IdXboxProgramActions {
  FETCH_DATA_START = "@idXboxProgram/FETCH_DATA_START",
  FETCH_DATA_SUCCESS = "@idXboxProgram/FETCH_DATA_SUCCESS",
  FETCH_DATA_ERROR = "@idXboxProgram/FETCH_DATA_ERROR",
}

export const idXboxProgramActions = {
  fetchData: createOnboardingAsyncAction(
    IdXboxProgramScope,
    IdXboxProgramActions.FETCH_DATA_START,
    () => ({}),
    IdXboxProgramActions.FETCH_DATA_SUCCESS,
    (data: IdXboxProgramDataResponse) => ({ data }),
    IdXboxProgramActions.FETCH_DATA_ERROR,
    (error: Error) => ({ error })
  ),
};
